<template>
  <div class="notification-icon">
    <div v-if="!reversed">
      <img
        src="@/assets/icons/info-grey.svg"
        @mousedown.prevent="onClick"
        class="notification-icon__img"
      />
      <span class="notification-icon__text">{{ text }}</span>
    </div>
    <div v-if="reversed">
      <span class="notification-icon__text">{{ text }}</span>
      <img
        src="@/assets/icons/info-grey.svg"
        @mousedown.prevent="onClick"
        class="notification-icon__img"
      />
    </div>
  </div>
</template>

<script src="./notification-icon.js"></script>
<style src="./notification-icon.scss" lang="scss"></style>
